/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CommunityCommentDto } from '../../models/community-comment-dto';

export interface CommunityCommentControllerFindByCommunityId$Params {
  communityId: string;
}

export function communityCommentControllerFindByCommunityId(http: HttpClient, rootUrl: string, params: CommunityCommentControllerFindByCommunityId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CommunityCommentDto>>> {
  const rb = new RequestBuilder(rootUrl, communityCommentControllerFindByCommunityId.PATH, 'get');
  if (params) {
    rb.path('communityId', params.communityId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CommunityCommentDto>>;
    })
  );
}

communityCommentControllerFindByCommunityId.PATH = '/api/community-comments/community/{communityId}';
